import apiHelpers from './apiHelpers';

export default {
    getAllUsers() {
        return apiHelpers.httpRequest('users', 'get');
    },
    inviteUser(data) {
        return apiHelpers.httpRequest('users', data, 'post');
    },
    updateUser(body, userId) {
        return apiHelpers.httpRequest(`users/${userId}`, body, 'put');
    },
    deleteUser(userId) {
        return apiHelpers.httpRequest(`users/${userId}`, {}, 'delete');
    },
};